import * as R from 'ramda';

import sportsApi from '../../utils/sportsApi';
import { normalize, schema } from 'normalizr';

const INSTAGRAM_PLATFORM_ID = 2;

const socialAccountsList = new schema.Entity('socialAccountsList', undefined, {
    // idAttribute *functions* must return the ids **value** (not key)
    idAttribute: value => value.account.platformUserId,
});

const getInstagramLinkedAccounts = store => async (state, clientId) => {
    const userClientId = state.user.selectedUserClientId;

    const loadingState = R.assocPath(
        [
            'clients',
            userClientId,
            'socialAccounts',
            'instagram',
            'isRequestingLinkedAccounts',
        ],
        true,
        state,
    );

    store.setState(loadingState);

    const response = await sportsApi
        .url(`/clients/${clientId}/authorized-accounts`)
        .query({ platformId: INSTAGRAM_PLATFORM_ID })
        .get()
        .json();

    const normalizedData = normalize(response, [socialAccountsList]);

    const accounts = normalizedData.entities.socialAccountsList || {};

    store.setState(
        R.evolve(
            {
                clients: {
                    [userClientId]: {
                        socialAccounts: {
                            instagram: {
                                isRequestingLinkedAccounts: R.F,
                                linkedAccounts: R.always(accounts),
                            },
                        },
                    },
                },
            },
            store.getState(),
        ),
        true,
    );
};

export default getInstagramLinkedAccounts;
